import React, {useEffect} from "react";
import {inject} from "mobx-react";
import {observer, useLocalObservable} from "mobx-react-lite";
import {useNavigate, useParams} from "react-router-dom";

function Request({DeviceStore}){

  const navigate = useNavigate();
  const {organisation_slug, shop_id, invite_id} = useParams();

  useEffect(() => {
    DeviceStore.guestRequest = true;
    return navigate(`/${organisation_slug}/${shop_id}`);
  })
  return null;
}

export default inject('DeviceStore')(observer(Request));
